const routePaths = {
  newHome: '/',
  frontOffice: '/bi',
  login: '/login',
  master: '/masterData/main',
  lookup: '/masterData/lookup',
  adminPage: '/admin',
  clientTable: '/clients',
  logout: '/logout',
  whiteLabeling: '/admin/white-labeling',
  vendorLabeling: '/admin/vendor-labeling',
  tenantAdmin: '/admin/tenant-admin',
  tenantManagement: '/admin/management',
  tenantRefresh: '/tenant-refresh',
  clientPortal: '/client-portal/onboarding',
  clientPortalQuestionary: '/client-portal/questionary',
  reportDefaultSetting: '/report/default-setting',
  oktaSso: '/sso',
  reports: '/bi/reports',
  settings: '/bi/settings',
  applications: '/bi/applications',
  enigma: '/bi/enigma',
  cohortBuilder: '/cohort-builder',
  activationEngine: '/activation-engine',
};

export default routePaths;